// extracted by mini-css-extract-plugin
export default {"galleryGrid":"GalleryGrid_galleryGrid__1C-VL"};